import { PropType } from '@vue/composition-api';
import { STATUS } from '@front-app/constants/state';

export const STEP_PROPS = {
	numSteps: {
		type: Number,
		required: true,
	},
	currentStep: {
		type: Number,
		required: true,
	},
	status: {
		type: String as PropType<STATUS>,
		required: true,
	},
} as const;
